/**
 * s60 -- caminhos e tempos da VIGA (marca v1.5.0). Arquivo so de constantes (o componente fica em VigaIcon.tsx).
 * Os SVGs sao COPIA do kit da Fabrica da Marca (`brand/svg/viga/`), servidos de `public/brand/viga/`.
 */
export const VIGA = {
  icone: '/brand/viga/viga_icone_claro.svg',
  iconePensando: '/brand/viga/viga_icone_pensando_claro.svg',
  selo: '/brand/viga/viga_selo.svg',
  seloPensando: '/brand/viga/viga_selo_pensando.svg',
} as const

/** O "pensando" do kit: 2 toques de 1,2 s -- depois disso o desenho volta ao parado. */
export const VIGA_TOQUES_MS = 2400

/** O sistema pediu menos movimento? (jsdom e navegadores antigos nao tem matchMedia: trata como "nao pediu".) */
export function prefereMenosMovimento(): boolean {
  try {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false
  } catch {
    return false
  }
}
